import { ScaleElement } from '@scale/base-element';

class ProductShare extends ScaleElement {
  setup() {
    // Web Share API (native mobile share sheet)
    const nativeBtn = this.querySelector('[data-share-native]');
    if (nativeBtn && navigator.share) {
      nativeBtn.hidden = false;
      const fallback = this.querySelector('.product-share__fallback');
      if (fallback) fallback.hidden = true;

      nativeBtn.addEventListener('click', async () => {
        try {
          await navigator.share({
            title: nativeBtn.dataset.shareTitle,
            url: nativeBtn.dataset.shareUrl,
          });
        } catch { /* user cancelled */ }
      }, { signal: this.signal });
    }

    // Copy link fallback
    for (const btn of this.querySelectorAll('[data-share-copy]')) {
      btn.addEventListener('click', () => this.#copyLink(btn), { signal: this.signal });
    }
  }

  async #copyLink(btn) {
    const url = btn.dataset.shareCopy;
    if (!url) return;

    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = Object.assign(document.createElement('input'), { value: url });
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }

    this.announce(window.Scale?.translations?.linkCopied || 'Link copied');
    btn.classList.add('product-share__link--copied');
    setTimeout(() => btn.classList.remove('product-share__link--copied'), 2000);
  }
}

if (!customElements.get('product-share')) {
  customElements.define('product-share', ProductShare);
}
